module.exports = __webpack_public_path__ + "img/logo.105f0ab1.png";